import React, {RefObject} from "react";
import {css} from "@emotion/react";

import {calculateRemSize as crs, listUnStyled, mb, onDesktop} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";

import {RankingCreationStep} from "./RankingCreationStep";

import titleGraph from "../../../images/step_3.svg";

interface IProps {
    scrollRefElem?: RefObject<HTMLDivElement | null>;
    className?: string;
}

export const RankingCreationSteps = (props: IProps) => {
    const {scrollRefElem, className} = props;

    const rankingCreationSteps = [
        "Bazujemy na informacjach, otrzymywanych co miesiąc od ponad 500 tys. użytkowników.",
        "Zbieramy informacje o tym, które inwestycje są najbardziej interesujące. Uwzględniamy zapytania do dewelopera, wykonane telefony czy liczbę obejrzanych ofert w danej inwestycji.",
        "Nasz algorytm tworzy finalne zestawienie, na bazie którego powstaje Ranking Inwestycji.",
        "Ogłaszamy trzy najlepsze inwestycje oraz przyznajemy wyróżnienia w danym regionie."
    ];

    return (
        <section css={creationStepsWrap} ref={scrollRefElem} className={className}>
            <div css={creationSteps}>
                <Text align="center" as="h2" variant="headline_3" css={mb(4)}>
                    Zobacz, jak powstał ranking
                </Text>
                <div css={stepsWrap}>
                    <img css={stepsImg} src={titleGraph} alt="Jak powstał ranking" />
                    <ul css={steps}>
                        {rankingCreationSteps.map((stepText, index) => (
                            <RankingCreationStep key={stepText.substring(0, 3)} text={stepText} place={index + 1} />
                        ))}
                    </ul>
                </div>
            </div>
        </section>
    );
};

// Styles
const creationStepsWrap = css`
    display: flex;
    align-items: center;
    justify-content: center;
`;

const creationSteps = css`
    max-width: 1128px;
`;

const stepsWrap = css`
    display: flex;
    flex-direction: column;
    gap: ${crs(3)};
    align-items: center;
    justify-content: center;

    ${onDesktop(css`
        flex-direction: row;
    `)}
`;

const stepsImg = css`
    width: 336px;

    ${onDesktop(css`
        width: auto;
        flex: 1 0 600px;
    `)}
`;

const steps = css`
    ${listUnStyled};
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: ${crs(3)};

    ${onDesktop(css`
        flex-direction: column;
    `)}
`;
